import {
  Button,
  DatePicker,
  Form,
  InputNumber,
  Row,
  Select,
  Space,
  Typography,
  Upload,
} from 'antd';
import moment from 'moment';
import TextArea from 'antd/lib/input/TextArea';
import { useEffect, useState } from 'react';
import { WorkRecord } from '../../modules/work-records';
import {
  MinusCircleOutlined,
  PlusOutlined,
  UploadOutlined,
} from '@ant-design/icons';
import { VendorType } from '../../modules/vendors';

const { Option } = Select;

interface WorkRecordCreateUpdateComponentProps {
  workRecord?: WorkRecord;
  invoiceCommon: any;
  uploadProps: any;
  onCreate: (data: any) => void;
  onCancel: () => void;
  findWorkRecord: (date: string) => any;
}

function WorkRecordCreateUpdateComponent({
  workRecord,
  invoiceCommon,
  uploadProps,
  onCancel,
  onCreate,
  findWorkRecord,
}: WorkRecordCreateUpdateComponentProps) {
  const [form] = Form.useForm();
  const [mount, setMount] = useState(true);
  const [gongjongList, setGongjongList] = useState<any[]>();
  const [vendorCompanyList, setVendorCompanyList] = useState<any[]>();
  const [jigjongList, setJigjongList] = useState<any[]>();
  let _workRecord: any;

  if (workRecord) {
    // title = '작업일보 수정';
    _workRecord = {
      ...workRecord,
      createdDate: moment(workRecord.createdDate, 'YYYY-MM-DD'),
    };
  } else {
    // title = '작업일보 생성';
    _workRecord = {
      tomorrowNote: '',
      issueNote: '',
      data: {
        workers: [],
        equipments: [],
        materials: [],
      },
    };
  }

  useEffect(() => {
    if (!mount) return;
    let children: any = [];

    children = [];
    for (const gongjong of invoiceCommon.gongjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={gongjong.id} value={gongjong.name}>
          {gongjong.name}
        </Option>,
      );
    }
    setGongjongList(children);

    children = [];
    for (const vendor of invoiceCommon.vendorList
      .filter((vendor: any) => vendor.type === VendorType.COMPANY)
      .sort((a: any, b: any) => a.name.localeCompare(b.name))) {
      children.push(
        <Option key={vendor.id} value={vendor.name}>
          {vendor.name}
        </Option>,
      );
    }
    setVendorCompanyList(children);

    children = [];
    for (const jigjong of invoiceCommon.jigjongList.sort((a: any, b: any) =>
      a.name.localeCompare(b.name),
    )) {
      children.push(
        <Option key={jigjong.id} value={jigjong.name}>
          {jigjong.name}
        </Option>,
      );
    }
    setJigjongList(children);

    return () => setMount(false);
  }, [invoiceCommon, mount]);

  const normFile = (e: any) => {
    let fileList = e.fileList;

    if (Array.isArray(e)) {
      return e;
    }
    return e && fileList;
  };

  return (
    <>
      {/* <Row>
        <Col span={12}>
          <Title level={3}>{title}</Title>
        </Col>
      </Row> */}
      <Form
        form={form}
        layout="vertical"
        onFinish={onCreate}
        initialValues={_workRecord}
      >
        <Form.Item
          name="createdDate"
          label="작업일"
          rules={[
            {
              required: true,
            },
            {
              async validator(_, value) {
                // const result = await findWorkRecord(value.format('YYYY-MM-DD'));
                // console.log(moment().isBefore(value));
                // if (!value || '2024-03-21' === value.format('YYYY-MM-DD')) {
                if (!value) {
                  // return Promise.reject(new Error('작업일을 선택하세요.'));
                  return Promise.resolve();
                } else if (moment().isBefore(value)) {
                  return Promise.reject(
                    new Error('미래 날짜는 입력할 수 없습니다.'),
                  );
                } else if (!!workRecord) {
                  return Promise.resolve();
                } else if (await findWorkRecord(value.format('YYYY-MM-DD'))) {
                  return Promise.reject(
                    new Error('작업일보이 이미 존재합니다.'),
                  );
                }
                return Promise.resolve();
              },
            },
          ]}
        >
          <DatePicker
            format="YYYY-MM-DD"
            style={{ width: '100%' }}
            disabled={!!workRecord}
          />
        </Form.Item>

        <Form.Item name="todayNote" label="금일작업내용">
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item name="tomorrowNote" label="명일예정사항">
          <TextArea rows={4} />
        </Form.Item>
        <Form.Item name="issueNote" label="특이사항">
          <TextArea rows={4} />
        </Form.Item>

        <Row style={{ marginBottom: '10px' }}>
          <Typography.Text>인력 투입현황</Typography.Text>
        </Row>
        <Form.List name={['data', 'workers']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    display: 'flex',
                  }}
                  align="baseline"
                >
                  <Form.Item
                    {...restField}
                    name={[name, 'gongjong']}
                    rules={[{ required: true, message: '공정을 선택하세요' }]}
                  >
                    <Select
                      allowClear
                      style={{ width: '140px' }}
                      placeholder="공정 선택"
                    >
                      {gongjongList}
                    </Select>
                  </Form.Item>
                  <Form.Item {...restField} name={[name, 'name']}>
                    <Select
                      style={{ width: '140px' }}
                      placeholder="업체명 선택"
                      allowClear
                    >
                      {vendorCompanyList}
                    </Select>
                  </Form.Item>
                  <Form.Item {...restField} name={[name, 'jigjong']}>
                    <Select
                      allowClear
                      style={{ width: '100px' }}
                      placeholder="직종 선택"
                    >
                      {jigjongList}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'numOfWorkers']}
                    rules={[
                      { required: true, message: '작업자수를 입력하세요' },
                    ]}
                  >
                    <InputNumber
                      placeholder="인원 수"
                      style={{ width: '70px' }}
                    />
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'numOfGongsu']}
                    rules={[
                      {
                        required: true,
                      },
                    ]}
                  >
                    <Select
                      style={{ width: '90px' }}
                      placeholder="작업량(공수)"
                    >
                      <Option value={0.5}>0.5(공수)</Option>
                      <Option value={1}>1(공수)</Option>
                      <Option value={1.5}>1.5(공수)</Option>
                      <Option value={2}>2(공수)</Option>
                    </Select>
                  </Form.Item>
                  <MinusCircleOutlined
                    onClick={() => {
                      remove(name);
                      // updatePriceField();
                    }}
                    rev={undefined}
                  />
                </Space>
              ))}
              <Form.Item>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined rev={undefined} />}
                >
                  추가
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <Form.List name={['data', 'equipments']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    display: 'flex',
                  }}
                  align="baseline"
                >
                  <MinusCircleOutlined
                    onClick={() => {
                      remove(name);
                    }}
                    rev={undefined}
                  />
                </Space>
              ))}
              <Form.Item hidden>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined rev={undefined} />}
                >
                  추가
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>
        <Form.List name={['data', 'materials']}>
          {(fields, { add, remove }) => (
            <>
              {fields.map(({ key, name, ...restField }) => (
                <Space
                  key={key}
                  style={{
                    display: 'flex',
                  }}
                  align="baseline"
                >
                  <MinusCircleOutlined
                    onClick={() => {
                      remove(name);
                    }}
                    rev={undefined}
                  />
                </Space>
              ))}
              <Form.Item hidden>
                <Button
                  type="dashed"
                  onClick={() => add()}
                  block
                  icon={<PlusOutlined rev={undefined} />}
                >
                  추가
                </Button>
              </Form.Item>
            </>
          )}
        </Form.List>

        <Form.Item
          name="file"
          label="현장사진"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload {...uploadProps}>
            <Button icon={<UploadOutlined rev={undefined} />}>
              사진 올리기
            </Button>
          </Upload>
        </Form.Item>

        <Row justify="center">
          <Form.Item>
            <Space size="middle">
              <Button htmlType="button" onClick={onCancel}>
                취소
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                style={{ width: '100px' }}
              >
                확인
              </Button>
            </Space>
          </Form.Item>
        </Row>
      </Form>
    </>
  );
}

export default WorkRecordCreateUpdateComponent;
